import { cn } from "@lib/ui/cn";
import Link from "next/link";
import * as React from "react";
import { UrlObject } from "url";

import { HrefObject } from "@/lib/types";

import { resolveCtaHref } from "../shared/cta";

export interface LinkProps extends Omit<React.ComponentPropsWithoutRef<typeof Link>, "href"> {
  className?: string;
  href?: HrefObject | UrlObject | string;
}

const LinkComponent = React.forwardRef<React.ComponentRef<typeof Link>, LinkProps>(
  ({ className, href, ...props }, ref) => {
    // Only resolve HrefObject or string; pass UrlObject through as-is
    const resolvedHref =
      href && typeof href === "object" && "linkType" in href
        ? resolveCtaHref(href as HrefObject)
        : href && typeof href === "string"
          ? resolveCtaHref(href)
          : href;

    if (!resolvedHref) return null;

    return <Link ref={ref} className={cn(className)} href={resolvedHref} {...props} />;
  },
);

LinkComponent.displayName = "Link";

export default LinkComponent;
